import i18n from '@dms/i18n';
import {useCountry} from '@dms/shared';

import {Field} from './primitives/Field';

export function OriginCountrySelect() {
  const {sortedCountriesOptions} = useCountry();

  return (
    <Field
      type="choice"
      name="originCountry"
      label={i18n.t('entity.vehicle.labels.countryOfOrigin')}
      options={sortedCountriesOptions ?? []}
    />
  );
}
